const ethers = require('ethers');

export async function getBalance() {
  try {
    // Provider for the current Ethereum-enabled browser
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const chainID = (await provider.getNetwork()).chainId;

    if (chainID === 84532) {
        const signer = provider.getSigner();

        // Get the public address of the current user
        const address = await signer.getAddress();
        
        // Get the balance of the address
        const balance = await provider.getBalance(address);

        // Convert the balance to Ether
        const etherBalance = ethers.utils.formatEther(balance);

        return etherBalance;
    } else {
      throw new Error('Invalid chain ID. Please connect to the Base Sepolia Testnet.');
    }
  } catch (error) {
    console.error('Error retrieving balance:', error);
    throw error;
  }
}

